module.exports = __webpack_public_path__ + "assets/img/a413090bf387a071a00218ce537a54c9.png";